export default {
  'customNotifications.title': 'Notificaciones Personalizadas',

  'notification.status.Pending': 'Pendiente',
  'notification.status.Finished': 'Finalizado',
  'notification.status.Rejected': 'Rechazado',
  'notification.status.Overdue': 'Vencido',
  'notification.status.Skipped': 'Omitido',
  'notification.status.Error': 'Error',
  'notification.status.Execution': 'Ejecución',

  'notification.addedUsers': 'Usuario Agregado',

  'customNotifications.form.isSendToApplicantEnabled': '¿Enviar al Solicitante?',
  'customNotifications.form.form': 'Formulario',
  'customNotifications.form.field': 'Campo',
  'customNotifications.form.variable': 'Variable',
  'customNotifications.form.emailDestinationCopyType': 'Tipo de Copia',
  'customNotifications.form.select.To': 'Para',
  'customNotifications.form.select.Copy': 'Copia',
  'customNotifications.form.select.CopyHidden': 'Copia Oculta',

  'customNotifications.mapping': 'Notificación',
  'customNotifications.addMapping': 'Agregar notificación',
  'customNotifications.noMappings': 'No hay notificaciones configuradas.',
};
